import { nextFrame } from "../../../library-js/animation/nextFrame";
import { LexCode } from "../../../library-js/dom-actions/LexCode";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";
import { LexerMatcherLibrary } from "../../../library-js/text/lexer/LexerMatcherLibrary";
import { GodotLibrary } from "../../../library-js/text/lexer/library/GodotLibrary";
import { Rokojori } from "../Rokojori";
import { GodotDocsFile } from "./GodotDocsFile";
import { GodotDocsIndexSelector } from "./GodotDocsIndexSelector";

export class GodotDocLinks
{
  static applyOnDocument()
  {

    let lexCode = LexCode.type.queryAll( document ).filter( lc => LexCode.language.from( lc ) === GodotLibrary.token );

    this.apply( lexCode );

    // lexCode.forEach( lc => this.applyOnLexCode( lc ) );
    
    // let elapsedMS = ( new Date().getTime() ) - time;

    // console.log( "Needed for highlighting:", elapsedMS / 1000, "sec" );
  } 
  
  static async apply( lexCodes:Element[] )
  {
    for ( let lc of lexCodes )
    {
      console.log( "processing:", lc );
      await this.process( lc );
      await nextFrame();
    }
  }

  static async process( e:Element )
  {
    let words =  HTMLEditor.nodeListToArray( e.querySelectorAll( "[data-type=\"CWORD\"]" ) );
    
    await nextFrame();

    let timeBarrier = new Date().getTime();
    let durationThreshold = 1000/120;

    let numWords = words.length;
    let counter = 0;

    // console.log( "Num words:", numWords );

    for ( let w of words )
    {
      // console.log( "Processing:", w );
      let currentTime = new Date().getTime();
      let elapsed = timeBarrier - currentTime;

      if ( elapsed > durationThreshold )
      {
        console.log( "Processed:", (100 * counter / numWords ).toFixed( 2 ), counter, numWords, )
        await nextFrame();
        timeBarrier = new Date().getTime();
      }

      counter ++;

      let type = w.textContent;

      if ( type == "string" )
      {
        type = "String";
      }

      let previousToken = this.getPreviousToken( w );

      if ( previousToken !== null && this.dataType.from( previousToken ) === "OPERATOR" && previousToken.textContent === "." )
      {
        continue;
      }

      let docInfo = GodotDocsIndexSelector.getDocInfoForAll( type );

      if ( docInfo == null )
      {
        continue;
      }

      let link = GodotDocsFile.getLink( docInfo );
      let anchor = HTMLEditor.wrapWithAnchorHref( w, link );
      Rokojori.$.resolveRootPaths( anchor );
    }
    

    // console.log( "Processed", counter );

    return Promise.resolve();

  }

  static dataType = new ElementAttribute( "type" );

  static isIgnoreType( e:Element )
  {
    let ignoreTypes = [ 
      LexerMatcherLibrary.WHITESPACE_MATCHER,
      LexerMatcherLibrary.BREAK_MATCHER,
      LexerMatcherLibrary.SINGLE_LINE_COMMENT_MATCHER,
      LexerMatcherLibrary.MULTI_LINE_COMMENT_MATCHER
    ]

    let type = GodotDocLinks.dataType.from( e );

    let matchingType = ignoreTypes.find( t => t.type == type );

    return matchingType !== null && matchingType !== undefined;
  }

  static getPreviousToken( e:Element ):Element
  {
    let it = e.previousSibling;

    if ( it != null && it.nodeType != Node.ELEMENT_NODE || this.isIgnoreType( it as Element ) )
    {
      it = e.previousSibling;
    }

    return it as Element;
  } 
  

  static applyOnLexCode( e:Element )
  {
    let words = e.querySelectorAll( "[data-type=\"CWORD\"]" );
    words.forEach(
      ( w )=>
      {
        let type = w.textContent;
        if ( type == "string" )
        {
          type = "String";
        }

        let previousToken = this.getPreviousToken( w );

        if ( previousToken !== null && this.dataType.from( previousToken ) === "OPERATOR" && previousToken.textContent === "." )
        {
          return;
        }

        let docInfo = GodotDocsIndexSelector.getDocInfoForAll( type );

        if ( docInfo == null )
        {
          return;
        }

        let link = GodotDocsFile.getLink( docInfo );
        let anchor = HTMLEditor.wrapWithAnchorHref( w, link );
        Rokojori.$.resolveRootPaths( anchor );

      }
    )
  }
}